<template>
  <div>
    <div class="main-layout">
      <nav class="toolbar">
        <div class="container my-3 pb-0">
          <div class="nav_left">
            <router-link style="text-decoration: none" to="/">
              <a class="logo">
                <img :src="logo" alt="BodyTalk" />
              </a>
            </router-link>
            <!----------------------nav links ------------------------------------------->
            <div class="nav_links">
              <div class="search_bar_parrent">
                <div class="search">
                  <!-- <input type="text" placeholder="Search..." />
                  <v-icon class="search-icon">search</v-icon> -->
                </div>
                <div class="header-btns d-flex align-center">
                  <v-dialog v-model="LanguageDialog" persistent max-width="750">
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        depressed
                        color="white"
                        v-bind="attrs"
                        v-on="on"
                        style="text-transform: none"
                        ><span :key="englishButtonText">{{
                          englishButtonText
                        }}</span></v-btn
                      >
                    </template>
                    <v-card>
                      <LanguageComponent
                        :languagecomponent="true"
                        @close="close()"
                        @languageSelected="updateEnglishButtonText"
                      />
                    </v-card>
                  </v-dialog>
                  <!-- <v-dialog
                    v-model="LanguageDialog2"
                    persistent
                    max-width="750"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn depressed color="white" v-bind="attrs" v-on="on"
                        >USD</v-btn
                      >
                    </template>
                    <v-card>
                      <currency-component
                        :currencycomponent="true"
                        @close="close()"
                      />
                    </v-card>
                  </v-dialog> -->
                  <router-link
                    v-if="!isLoggedIn"
                    to="/store/cart"
                    class="cart-icon-container"
                    ><v-icon class="mr-3" v-if="showIcon">mdi-cart-plus</v-icon>
                    <span
                      class="cart-badge"
                      v-if="showIcon && GetCartItems?.length > 0"
                      >{{ totalQuantity }}</span
                    >
                  </router-link>
                  <v-btn
                    color="primary"
                    v-if="!isLoggedIn"
                    @click="openLogin()"
                    depressed
                    >Sign In
                  </v-btn>
                  <div v-else>
                    <v-menu
                      transition="scroll-y-transition"
                      offset-y
                      nudge-top="-10" 
                      nudge-left="250" 
                      color="transparent"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <span class="notification-icon-container" v-bind="attrs"
                          v-on="on"
                            ><v-icon class="mr-3"
                              >mdi-bell-outline</v-icon
                            >
                            <span
                              class="notification-badge"
                              v-if="notificationsCount > 0"         
                              >{{ notificationsCount }}</span
                            >
                          </span>
                      </template>
                      <v-card flat class="py-3 desktop-notification-card" style="width:330px;" color="#edf0f6">
                        <div class="px-5 d-flex justify-space-between align-center">
                          <span><b>Notifications</b></span>
                          <div class="d-flex align-center gap-1" @click="markAllNotificationsAsRead">
                            <v-icon class="text-primary"
                                >mdi-check-all</v-icon
                              >
                            <span class="cursor-pointer">Mark all as read</span>
                          </div>
                        </div>
                        <hr class="mt-3"/>
                        <v-list
                          v-if="userNotifications?.notificationList?.length == 0"
                          class="px-5 pt-1 index_h7_text_style"
                          color="transparent"
                        >
                          No notifications available
                        </v-list>
                        <div style="max-height:320px; z-index:100; overflow:auto; scrollbar-width: none; -ms-overflow-style: none;" class="scrollable-container">
                          <div
                            class="px-5 pt-1 index_h7_text_style notification-item d-flex gap-2 items-center"
                            v-for="(notification, index) in this.userNotifications?.notificationList?.slice(0,10)"
                            :key="notification.ReferenceID"
                            @click="markAsRead(notification.NotificationID)"
                            :class="{ 'notification-read': notification.isUserRead, 'notification-unread': !notification.isUserRead }"
                          >
                            <div>
                              <div>
                                <router-link v-if="notification.NotificationTypeID == 1" :key="notification.ReferenceID" :to="`/forum/postdetail/${notification.ReferenceID}`" style="text-decoration:none;">
                                  <span class="text-black">The forum post you are following has updates - </span>
                                  <span class="text-primary"><b>{{ notification.NotificationContent }}</b></span>
                                </router-link>
                                <router-link v-if="notification.NotificationTypeID == 2" :key="notification.ReferenceID" :to="`/article/${notification.ReferenceID}`" style="text-decoration:none;">
                                  <span class="text-black">A new blog article has been added - </span>
                                  <span class="text-primary"><b>{{ notification.NotificationContent }}</b></span>
                                </router-link>
                                <router-link v-if="notification.NotificationTypeID == 3" to="/downloads" style="text-decoration:none;">
                                  <span class="text-black">A new download is available - </span>
                                  <span class="text-primary"><b>{{ notification.NotificationContent }}</b></span>
                                </router-link>
                                <router-link v-if="notification.NotificationTypeID == 4" to="/testimonial" style="text-decoration:none;">
                                  <span class="text-black">A new testimonial has been posted - </span>
                                  <span class="text-primary"><b>See Testimonials</b></span>
                                </router-link>
                              </div>
                              <div><span style="font-size:14px">{{ formatTimeDifference(notification.CreatedAt) }}</span></div>
                            </div>
                            <div class="d-flex justify-center">
                              <div v-if="!notification.isUserRead" style="height:10px; width:10px; background-color:#5757db; border-radius:50%"></div>
                            </div>
                          </div>
                          <!-- <v-list
                            class="px-3 pt-1 index_h7_text_style notification-item"
                            v-if="blogNotifications.length > 0"
                            v-for="(notification, index) in blogNotifications"
                            :key="notification.ReferenceID" 
                            @click="markAsRead(notification.NotificationID)"    
                          >
                            <router-link :key="notification.ReferenceID" :to="`/article/${notification.ReferenceID}`" style="text-decoration:none;">
                              <span class="text-black">A new blog article has been added - </span>
                              <span class="text-primary"><b>{{ notification.NotificationContent }}</b></span>
                            </router-link>
                          </v-list>
                          <v-list
                            class="px-3 pt-1 index_h7_text_style notification-item"
                            v-if="downloadNotifications.length > 0"
                            v-for="(notification, index) in downloadNotifications"
                            :key="index"    
                            @click="markAsRead(notification.NotificationID)"     
                          >
                            <router-link to="/downloads" style="text-decoration:none;">
                              <span class="text-black">A new download is available - </span>
                              <span class="text-primary"><b>{{ notification.NotificationContent }}</b></span>
                            </router-link>
                          </v-list>
                          <v-list
                            class="px-3 pt-1 index_h7_text_style notification-item"
                            v-if="testimonialNotifications.length > 0"
                            v-for="(notification, index) in testimonialNotifications"
                            :key="index"   
                            @click="markAsRead(notification.NotificationID)"      
                          >
                            <router-link to="/testimonial" style="text-decoration:none;">
                              <span class="text-black">A new testimonial has been posted - </span>
                              <span class="text-primary"><b>See Testimonials</b></span>
                            </router-link>
                          </v-list> -->
                        </div>
                        <div class="d-flex justify-center px-3 py-2">
                          <router-link to="/notifications" style="text-decoration:none;">
                            <v-btn depressed color="transparent" class="text-primary" style="text-transform: initial;">
                              <span class="pa-0 ma-0"> See all notifications </span>
                              <v-icon>mdi-arrow-right-thin</v-icon>
                            </v-btn>
                          </router-link>
                        </div>
                      </v-card>
                    </v-menu>
                    
                    <router-link to="/store/cart" class="cart-icon-container"
                      ><v-icon class="mr-3" v-if="showIcon"
                        >mdi-cart-plus</v-icon
                      >
                      <span
                        class="cart-badge"
                        v-if="showIcon && GetCartItems?.length > 0"
                        >{{ totalQuantity }}</span
                      >
                    </router-link>
                    <v-menu location="start" offset-y left>
                      <template v-slot:activator="{ on, attrs }">
                        <button
                          v-bind="attrs"
                          v-on="on"
                          @click="openUserMenu"
                        >
                          <!-- <v-icon>mdi-account-circle</v-icon> -->
                          <v-avatar
                            size="30px"
                            v-if="
                              GetUserWeb?.ProfileImage != '' &&
                              GetUserWeb?.ProfileImage != null &&
                              GetUserWeb?.ProfileImage != undefined
                            "
                            
                            style="
                              overflow: hidden;
                              background-color: transparent;
                            "
                          >
                            <img
                              v-if="GetUserWeb?.ProfileImage"
                              alt="Avatar"
                              :src="GetUserWeb?.ProfileImage"
                              style="
                                width: 100%;
                                height: 100%;
                                object-fit: cover;
                                object-position: center;
                                background-color: white;
                              "
                              @error="setDefaultImage"
                            />
                          </v-avatar>
                          <v-avatar size="30px" v-else>
                            <img
                              height="30"
                              width="30"
                              alt="Avatar"
                              src="https://www.freeiconspng.com/thumbs/profile-icon-png/profile-icon-1.png"
                            />
                          </v-avatar>
                        </button>
                      </template>
                      <v-card flat>
                        <v-card-text class="text-subtitle-1">
                          <b class="ISlogin_text-style" style="text-transform:capitalize">
                            Hi, <span v-if="GetUserWeb?.FirstName === ' '" class="notranslate">{{ GetUserWeb?.LastName }}</span>
                            <span v-else class="notranslate">{{ GetUserWeb?.FirstName }}</span>
                          </b>
                          <!-- <v-divider class="my-3"></v-divider> -->

                          <v-list>
                            <div
                              class="mt-5"
                              v-for="navItem in filteredMenuLinks"
                              :key="navItem.name"
                            >
                              <div
                                style="
                                  display: flex;
                                  align-items: end;
                                  gap: 12px !important;
                                  font-size: 20px;
                                  color: rgba(34, 34, 34, 0.7);
                                "
                                class="mb-3"
                                v-if="navItem.name != 'divider'"
                              >
                                <router-link
                                  style="text-decoration: none"
                                  :to="navItem.route"
                                  class="d-flex pl-[4px]"
                                >
                                  <span v-if="navItem.iconn" class="px-1 mr-3">
                                    <v-img
                                      :src="navItem.iconn"
                                      class=""
                                    ></v-img>
                                  </span>
                                  <v-icon
                                    v-else="navItem.icon"
                                    class="px-1 mr-3"
                                    >{{ navItem.icon }}</v-icon
                                  >

                                  <span class="ISlogin_text-style pa-0 ma-0">
                                    <!-- v-text="navItem.name" -->
                                    <template v-if="navItem.name === 'Manuals'">
                                      <ChangeLanguageComponent
                                        :langName="languageObject.Manuals"
                                      />
                                    </template>
                                    <template v-else>
                                      {{ navItem.name }}
                                    </template>
                                  </span>
                                  <!-- <span
                                    style="margin-left: -0.3rem !important"
                                    class="ISlogin_text-style pa-0 ma-0 mr-0"
                                    v-text="navItem.name2"
                                  >
                                  </span> -->
                                </router-link>
                              </div>
                              <v-divider v-else class="my-3"></v-divider>
                            </div>
                            <v-divider class="my-3"></v-divider>
                            <v-card
                              class="cursor_pointer"
                              flat
                              to="/profile/membership"
                            >
                              <v-icon class="mr-4" style="color: #d18911"
                                >mdi-wallet-membership
                              </v-icon>
                              <span
                                class="ISlogin_text-style pa-0 ma-0"
                                style="color: #d18911"
                              >
                                Update
                                <span>
                                  <ChangeLanguageComponent
                                        :langName="languageObject.Membership"
                                      />
                                </span>
                              </span>
                              <v-icon class="ml-6">mdi-chevron-right </v-icon>
                            </v-card>
                            <v-divider class="my-3"></v-divider>
                            <v-card
                              flat
                              to="/profile"
                              class="mt-2 cursor_pointer"
                            >
                              <span class="ISlogin_text-style">
                                Account Settings
                              </span>
                            </v-card>
                            <div
                              class="mt-3 pa-0 cursor_pointer"
                              block
                              color="transparent"
                              depressed
                              @click="SignOut"
                            >
                              <div style="width: 100%">
                                <div
                                  class="ISlogin_text-style"
                                  style="text-transform: none"
                                >
                                  Sign Out
                                </div>
                              </div>
                            </div>
                          </v-list>
                        </v-card-text>
                      </v-card>
                    </v-menu>
                  </div>
                </div>
              </div>
              <div class="spacing_header_div">
                <v-menu
                  transition="scroll-y-transition"
                  offset-y
                  color="transparent"
                >
                  <template v-slot:activator="{ on, attr }">
                    <v-btn
                      color="transparent"
                      variant="flat"
                      v-bind="attr"
                      v-on="on"
                      depressed
                      class="text p-2"
                    >
                      <span class="text">Explore </span
                      ><v-icon style="font-size: x-large; color: #595459">
                        mdi-menu-down</v-icon
                      >
                    </v-btn>
                  </template>

                  <v-list class="mt-1" color="white">
                    <router-link style="text-decoration: none" to="/modalities">
                      <div class="text px-3" link>Healing Systems</div>
                    </router-link>
                    <router-link style="text-decoration: none" to="/membership">
                      <div class="text px-3" link>
                        <ChangeLanguageComponent
                                        :langName="languageObject.Membership"
                                      />
                      </div>
                    </router-link>
                    <router-link to="/blog" style="text-decoration: none">
                      <div class="text px-3" link>Blog</div>
                    </router-link>
                    <router-link
                      style="text-decoration: none"
                      to="/testimonial"
                    >
                      <div class="text px-3" link>Testimonials</div>
                    </router-link>
                    <router-link to="/Video" style="text-decoration: none">
                      <div class="text px-3" link>Videos</div>
                    </router-link>
                    <router-link
                      style="text-decoration: none; width: 100%"
                      to="/company"
                      class="link"
                    >
                      <div class="text px-3" link>About Us</div>
                    </router-link>
                    <!-- <router-link to="/helpcenter" class="d-flex link">
                      <div class="text px-3" link>Help Center</div>
                    </router-link> -->
                    <div
                      class="text px-3"
                      link
                      @click="contactusmodel()"
                      style="cursor: pointer"
                    >
                      Contact Us
                    </div>
                  </v-list>
                </v-menu>

                <v-menu
                  transition="scroll-y-transition"
                  offset-y
                  color="transparent"
                >
                  <template v-slot:activator="{ on, attr }">
                    <v-btn
                      color="transparent"
                      variant="flat"
                      v-bind="attr"
                      v-on="on"
                      depressed
                      class="text p-2"
                    >
                      <span class="text">Learn</span
                      ><v-icon style="font-size: x-large; color: #595459">
                        mdi-menu-down</v-icon
                      >
                    </v-btn>
                  </template>
                  <v-list class="mt-1" color="white" style="display: grid">
                    <router-link to="/courses" class="link">
                      <div class="text px-3" link>Live Courses</div>
                    </router-link>
                    <router-link to="/selfstudy" class="link">
                      <div class="text px-3" link>
                        <ChangeLanguageComponent
                          :langName="languageObject.SelfStudyCourses"
                      />
                      </div>
                    </router-link>
                    <router-link to="/courselibrary" class="link">
                      <div class="text px-3" link>Course List</div>
                    </router-link>
                  </v-list>
                </v-menu>
                <v-menu
                  transition="scroll-y-transition"
                  offset-y
                  color="transparent"
                >
                  <template v-slot:activator="{ on, attr }">
                    <v-btn
                      color="transparent"
                      variant="flat"
                      v-bind="attr"
                      v-on="on"
                      depressed
                      class="text p-2"
                    >
                      <span class="text"
                        ><ChangeLanguageComponent
                          :langName="languageObject.Practitioners"
                      /></span>
                      <v-icon style="font-size: x-large; color: #595459"
                        >mdi-menu-down</v-icon
                      >
                    </v-btn>
                  </template>
                  <v-list class="mt-1" color="white" style="display: grid">
                    <router-link to="/bodytalkpractitioners" class="link">
                      <div class="text px-3" link :class="{ notranslate: getFlag === 'Portuguese' }"><ChangeLanguageComponent :langName="languageObject.BodyTalk"/></div>
                    </router-link>
                    <router-link to="/breakthroughpractitioners" class="link">
                      <div class="text px-3" link :class="{ notranslate: getFlag === 'Portuguese' }">
                        <ChangeLanguageComponent
                          :langName="languageObject.BreakThrough"
                      />
                      </div>
                    </router-link>
                    <!-- <router-link to="/" class="link">
                      <div class="text px-3" link>Legacy Sessions</div>
                    </router-link> -->
                  </v-list>
                </v-menu>
                <v-menu
                  transition="scroll-y-transition"
                  offset-y
                  color="transparent"
                >
                  <template v-slot:activator="{ on, attr }">
                    <v-btn
                      color="transparent"
                      variant="flat"
                      v-bind="attr"
                      v-on="on"
                      depressed
                      class="text p-2"
                    >
                      <span class="text">Careers</span
                      ><v-icon style="font-size: x-large; color: #595459">
                        mdi-menu-down</v-icon
                      >
                    </v-btn>
                  </template>
                  <v-list class="mt-1" color="white" style="display: grid">
                    <router-link to="/becomepractitioner" class="link">
                      <div class="text px-3" link>
                        Become a
                        <ChangeLanguageComponent
                          :langName="languageObject.Practitioner"
                        />
                      </div>
                    </router-link>
                    <router-link
                      to="/becomeinstructor"
                      class="link"
                      v-if="isLoggedIn"
                    >
                      <div class="text px-3" link>
                        Become an
                        <ChangeLanguageComponent
                          :langName="languageObject.Instructor"
                        />
                      </div>
                    </router-link>
                    <!-- <div class="text px-3" link>Non-Profit Work</div> -->
                  </v-list>
                </v-menu>

                <v-menu
                  transition="scroll-y-transition"
                  offset-y
                  color="transparent"
                >
                  <template v-slot:activator="{ on, attr }">
                    <v-btn
                      color="transparent"
                      variant="flat"
                      depressed
                      v-bind="attr"
                      v-on="on"
                      class="p-2"
                    >
                      <span class="text"> <ChangeLanguageComponent :langName="languageObject.Store" /></span
                      ><v-icon style="font-size: x-large; color: #595459">
                        mdi-menu-down</v-icon
                      >
                    </v-btn>
                  </template>
                  <v-list class="mt-1" color="white">
                    <router-link to="/store" class="d-flex link">
                      <div class="text px-3" link @click="showicon = true">
                        <ChangeLanguageComponent :langName="languageObject.Products" />
                      </div>
                    </router-link>
                    <router-link to="/selfstudy" class="link">
                      <div class="text px-3" link>
                        <ChangeLanguageComponent
                          :langName="languageObject.SelfStudyCourses"
                      />
                      </div>
                    </router-link>
                  </v-list>
                </v-menu>
                <v-btn
                  v-if="isLoggedIn && GetUserWeb?.Id !== 3456"
                  color="transparent"
                  variant="flat"
                  class="text p-2"
                  depressed
                >
                  <router-link class="text link" link to="/forum">
                    <span class="text">Forums</span></router-link
                  >
                </v-btn>
              </div>
            </div>
            <!-------------------end---nav links ------------------------------------------->
          </div>
          <!-----------------header btns-------------------------------->

          <!-----------------header btns-------------------------------->
        </div>
      </nav>
      <!------------------mobile navigation bar start----------------------------------------->
      <nav
        class="toolbar toolbar-mobile"
        :class="{ 'toolbar-scrolled': scrolled }"
      >
        <div class="d-flex justify-space-between" style="width: 100%">
          <div class="d-flex align-center">
            <v-menu offset-y>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  depressed
                  class="btn-menu"
                  color="transparent"
                  icon
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon style="color: #d18911" v-if="!isSidebarOpen"
                    >mdi-dots-grid</v-icon
                  >
                  <v-icon style="color: #d18911" v-if="isSidebarOpen"
                    >mdi-close</v-icon
                  >
                </v-btn>
              </template>
              <v-list class="pa-4">
                <div
                  class="sidebar side_btns_styles"
                  style="
                    display: flex;
                    flex-direction: column;
                    align-items: start;
                  "
                >
                  <v-menu
                    transition="scroll-y-transition"
                    offset-y
                    color="transparent"
                    style="flex-basis: 100%"
                  >
                    <template v-slot:activator="{ on, attr }">
                      <v-btn
                        color="transparent"
                        variant="flat"
                        v-bind="attr"
                        v-on="on"
                        depressed
                        class="text mb-3 p-2"
                        style="justify-content: space-between; min-width: 150px"
                      >
                        <span class="text"> Explore</span
                        ><v-icon style="font-size: x-large; color: #595459">
                          mdi-menu-down</v-icon
                        >
                      </v-btn>
                    </template>

                    <v-list class="mt-1" color="white">
                      <router-link
                        style="text-decoration: none"
                        to="/modalities"
                      >
                        <div class="text px-3" link>Healing Systems</div>
                      </router-link>
                      <router-link
                        style="text-decoration: none"
                        to="/membership"
                      >
                        <div class="text px-3" link>
                          <ChangeLanguageComponent
                                        :langName="languageObject.Membership"
                                      />
                        </div>
                      </router-link>
                      <router-link to="/blog" style="text-decoration: none">
                        <div class="text px-3" link>Blog</div>
                      </router-link>
                      <router-link
                        style="text-decoration: none"
                        to="/testimonial"
                      >
                        <div class="text px-3" link>Testimonials</div>
                      </router-link>
                      <router-link to="/Video" style="text-decoration: none">
                        <div class="text px-3" link>Media / Video</div>
                      </router-link>

                      <router-link
                        style="text-decoration: none; width: 100%"
                        to="/company"
                        class="link"
                      >
                        <div class="text px-3" link>About Us</div>
                      </router-link>
                      <!-- <router-link to="/helpcenter" class="d-flex link">
                        <div class="text px-3" link>Help Center</div>
                      </router-link> -->
                      <div
                        class="text px-3"
                        link
                        @click="contactusmodel()"
                        style="cursor: pointer"
                      >
                        Contact Us
                      </div>
                      <!-- <div class="text px-3" link>FAQ </div> -->
                    </v-list>
                  </v-menu>
                  <v-menu
                    transition="scroll-y-transition"
                    offset-y
                    color="transparent"
                    style="flex-basis: 100%"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        color="transparent"
                        variant="flat"
                        depressed
                        v-bind="attrs"
                        v-on="on"
                        class="text p-2 mb-2"
                        style="justify-content: space-between; min-width: 150px"
                      >
                        <span class="text">Learn</span
                        ><v-icon style="font-size: x-large; color: #595459">
                          mdi-menu-down</v-icon
                        >
                      </v-btn>
                    </template>
                    <v-list class="py-0" color="">
                      <router-link to="/courses" class="link">
                        <div class="text px-3" link>Live Courses</div>
                      </router-link>
                    </v-list>
                    <v-list class="py-0 pt-0" color="">
                      <router-link to="/selfstudy" class="link">
                        <div class="text px-3" link>
                          <ChangeLanguageComponent
                          :langName="languageObject.SelfStudyCourses"
                      />
                        </div>
                      </router-link>
                    </v-list>
                    <v-list class="pt-0 py-0">
                      <router-link to="/courselibrary" class="link">
                        <div class="text px-3" link>Course List</div>
                      </router-link>
                    </v-list>
                  </v-menu>
                  <v-menu
                    transition="scroll-y-transition"
                    offset-y
                    color="white"
                    style="flex-basis: 100%"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        color="transparent"
                        variant="flat"
                        v-bind="attrs"
                        depressed
                        v-on="on"
                        class="text p-2"
                        style="justify-content: space-between; min-width: 150px"
                      >
                        <span class="text"
                          ><ChangeLanguageComponent
                          :langName="languageObject.Practitioner" /></span
                        ><v-icon style="font-size: x-large; color: #595459"
                          >mdi-menu-down</v-icon
                        >
                      </v-btn>
                    </template>
                    <v-list class="mt-1" color="py-0 ">
                      <router-link to="/bodytalkpractitioners" class="link">
                        <div class="px-3 text" link><ChangeLanguageComponent :langName="languageObject.BodyTalk"/></div>
                      </router-link>
                    </v-list>
                    <v-list class="py-0">
                      <router-link to="/breakthroughpractitioners" class="link">
                        <div class="py-0 px-3 text" link>
                          <ChangeLanguageComponent
                          :langName="languageObject.BreakThrough"
                      />
                        </div>
                      </router-link>
                    </v-list>
                    <!-- <v-list class="py-0">
                      <router-link to="/" class="link">
                        <div class="py-0 px-3 text" link>Legacy Sessions</div>
                      </router-link>
                    </v-list> -->
                  </v-menu>
                  <v-menu
                    transition="scroll-y-transition"
                    offset-y
                    color="transparent"
                    style="flex-basis: 100%"
                  >
                    <template v-slot:activator="{ on, attr }">
                      <v-btn
                        color="transparent"
                        variant="flat"
                        v-bind="attr"
                        v-on="on"
                        depressed
                        class="text mb-3 p-2"
                        style="justify-content: space-between; min-width: 150px"
                      >
                        <span class="text">Careers</span
                        ><v-icon style="font-size: x-large; color: #595459">
                          mdi-menu-down</v-icon
                        >
                      </v-btn>
                    </template>
                    <v-list
                      class="mt-1 py-0"
                      color="white"
                      style="display: grid"
                    >
                      <router-link to="/becomepractitioner" class="link">
                        <div class="py-0 px-3 text" link>
                          Become a
                          <ChangeLanguageComponent
                            :langName="languageObject.Practitioner"
                          />
                        </div>
                      </router-link>
                      <router-link to="/becomeinstructor" class="link">
                        <div class="py-0 px-3 text" link>
                          Become an
                          <ChangeLanguageComponent
                            :langName="languageObject.Instructor"
                          />
                        </div>
                      </router-link>
                      <!-- <div class="text" link>Non-Profit Work</div> -->
                    </v-list>
                  </v-menu>

                  <v-menu
                    transition="scroll-y-transition"
                    offset-y
                    color="transparent"
                    style="flex-basis: 100%"
                  >
                    <template v-slot:activator="{ on, attr }">
                      <v-btn
                        color="transparent"
                        variant="flat"
                        depressed
                        v-bind="attr"
                        v-on="on"
                        class="p-2"
                        style="justify-content: space-between; min-width: 150px"
                      >
                        <span class="py-0 text"><ChangeLanguageComponent :langName="languageObject.Store" /></span
                        ><v-icon style="font-size: x-large; color: #595459">
                          mdi-menu-down</v-icon
                        >
                      </v-btn>
                    </template>
                    <v-list class="mt-1 py-0" color="white">
                      <router-link to="/store" class="d-flex link">
                        <div
                          class="py-0 px-3 text"
                          link
                          @click="showicon = true"
                        >
                          <ChangeLanguageComponent :langName="languageObject.Products" />
                        </div>
                      </router-link>
                      <router-link to="/selfstudy" class="link">
                        <div class="py-0 px-3 text" link>
                          <ChangeLanguageComponent
                          :langName="languageObject.SelfStudyCourses"
                      />
                        </div>
                      </router-link>
                      <!-- <div class="text" link>Products</div> -->
                    </v-list>
                  </v-menu>
                  <v-menu
                    transition="scroll-y-transition"
                    offset-y
                    color="transparent"
                    style="flex-basis: 100%"
                    v-if="isLoggedIn && GetUserWeb?.Id !== 3456"
                  >
                    <template v-slot:activator="{ on, attr }">
                      <v-btn
                        color="transparent"
                        variant="flat"
                        v-bind="attr"
                        v-on="on"
                        class="text p-2"
                        depressed
                        style="justify-content: space-between; min-width: 150px"
                      >
                        <span class="text">Forums</span
                        ><v-icon style="font-size: x-large; color: #595459">
                          mdi-menu-down</v-icon
                        >
                      </v-btn>
                    </template>

                    <v-list class="mt-1" color="white">
                      <router-link class="text px-3 link" link to="/forum"
                        >Go to Forum
                      </router-link>
                    </v-list>
                  </v-menu>

                  <div class="">
                    <v-dialog
                      v-model="LanguageDialog"
                      persistent
                      max-width="750"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          depressed
                          color="white"
                          class="mt-4 p-2"
                          v-bind="attrs"
                          v-on="on"
                          ><span :key="englishButtonText">{{
                          englishButtonText
                        }}</span></v-btn
                        >
                      </template>
                      <v-card>
                        <LanguageComponent
                          :languagecomponent="true"
                          @close="close()"
                          @languageSelected="updateEnglishButtonText"
                        />
                      </v-card>
                    </v-dialog>
                    <!-- <v-dialog
                      v-model="LanguageDialog2"
                      persistent
                      max-width="750"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          depressed
                          color="white"
                          class="mt-4"
                          v-bind="attrs"
                          v-on="on"
                          >USD</v-btn
                        >
                      </template>
                      <v-card>
                        <currency-component
                          :currencycomponent="true"
                          @close="close()"
                        />
                      </v-card>
                    </v-dialog> -->
                  </div>
                </div>
              </v-list>
            </v-menu>
            <!-- uncomment if you want to search field here; all other functionality is already implemented -->
            <!-- <v-icon class="mx-3" @click="drawersearchmobile = true"
              >mdi-magnify</v-icon
            > -->
          </div>
          <div class="logo">
            <router-link to="/">
              <!-- <img src="img/logos/bodytalk-logo_mini.svg" alt="BodyTalk" /> -->
              <img :src="logo" alt="BodyTalk" />
            </router-link>
          </div>
          <v-icon
            color="primary"
            v-if="!isLoggedIn"
            @click="openLogin()"
            depressed
            >mdi-login-variant
          </v-icon>
          <div v-else>
            <v-menu
              transition="scroll-y-transition"
              offset-y
              nudge-top="-10" 
              nudge-left="250" 
              color="transparent"
            >
              <template v-slot:activator="{ on, attrs }">
                <span class="notification-icon-container" v-bind="attrs"
                  v-on="on"
                    ><v-icon class="mr-3"
                      >mdi-bell-outline</v-icon
                    >
                    <span
                      class="notification-badge"
                      v-if="notificationsCount > 0"         
                      >{{ notificationsCount }}</span
                    >
                  </span>
              </template>
              <v-card flat class="py-3 mbl-notification-card" style="width:330px" color="#edf0f6">
                <div class="px-5 d-flex justify-space-between align-center">
                  <span><b>Notifications</b></span>
                  <div class="d-flex align-center gap-1" @click="markAllNotificationsAsRead">
                    <v-icon class="text-primary"
                        >mdi-check-all</v-icon
                      >
                    <span class="cursor-pointer">Mark all as read</span>
                  </div>
                </div>
                <hr class="mt-3"/>
                <v-list
                  v-if="userNotifications?.notificationList?.length == 0"
                  class="px-5 pt-1 index_h7_text_style"
                  color="transparent"
                >
                  No notifications available
                </v-list>
                <div style="max-height:320px; z-index:100; overflow:auto; scrollbar-width: none; -ms-overflow-style: none;" class="scrollable-container">
                  <div
                    class="px-5 pt-1 index_h7_text_style notification-item d-flex gap-2 items-center"
                    v-for="(notification, index) in this.userNotifications?.notificationList?.slice(0,10)"
                    :key="notification.ReferenceID"
                    @click="markAsRead(notification.NotificationID)"
                    :class="{ 'notification-read': notification.isUserRead, 'notification-unread': !notification.isUserRead }"
                  >
                    <div>
                      <div>
                        <router-link v-if="notification.NotificationTypeID == 1" :key="notification.ReferenceID" :to="`/forum/postdetail/${notification.ReferenceID}`" style="text-decoration:none;">
                          <span class="text-black">The forum post you are following has updates - </span>
                          <span class="text-primary"><b>{{ notification.NotificationContent }}</b></span>
                        </router-link>
                        <router-link v-if="notification.NotificationTypeID == 2" :key="notification.ReferenceID" :to="`/article/${notification.ReferenceID}`" style="text-decoration:none;">
                          <span class="text-black">A new blog article has been added - </span>
                          <span class="text-primary"><b>{{ notification.NotificationContent }}</b></span>
                        </router-link>
                        <router-link v-if="notification.NotificationTypeID == 3" to="/downloads" style="text-decoration:none;">
                          <span class="text-black">A new download is available - </span>
                          <span class="text-primary"><b>{{ notification.NotificationContent }}</b></span>
                        </router-link>
                        <router-link v-if="notification.NotificationTypeID == 4" to="/testimonial" style="text-decoration:none;">
                          <span class="text-black">A new testimonial has been posted - </span>
                          <span class="text-primary"><b>See Testimonials</b></span>
                        </router-link>
                      </div>
                      <div><span style="font-size:14px">{{ formatTimeDifference(notification.CreatedAt) }}</span></div>
                    </div>
                    <div class="d-flex justify-center">
                      <div v-if="!notification.isUserRead" style="height:10px; width:10px; background-color:#5757db; border-radius:50%"></div>
                    </div>
                  </div>
                          
                </div>
                <div class="d-flex justify-center px-3 py-2">
                  <router-link to="/notifications" style="text-decoration:none;">
                    <v-btn depressed color="transparent" class="text-primary" style="text-transform: initial;">
                      <span class="pa-0 ma-0"> See all notifications </span>
                      <v-icon>mdi-arrow-right-thin</v-icon>
                    </v-btn>
                  </router-link>
                </div>
              </v-card>
                    </v-menu>
            <router-link to="/store/cart" class="cart-icon-container">
              <v-icon class="mr-3" v-if="showIcon">mdi-cart-plus</v-icon>
              <span
                class="cart-badge"
                v-if="showIcon && GetCartItems?.length > 0"
              >
                {{ totalQuantity }}
              </span>
            </router-link>
            <v-menu location="start" offset-y left>
              <template v-slot:activator="{ on, attrs }">
                <button v-bind="attrs" v-on="on" @click="openUserMenu">
                  <!-- <v-icon>mdi-account-circle</v-icon> -->
                  <v-avatar
                    size="30px"
                    v-if="
                      GetUserWeb?.ProfileImage != '' &&
                      GetUserWeb?.ProfileImage != null &&
                      GetUserWeb?.ProfileImage != undefined
                    "
                  >
                    <img
                      v-if="GetUserWeb?.ProfileImage"
                      alt="Avatar"
                      :src="GetUserWeb?.ProfileImage"
                      @error="setDefaultImage"
                      style="object-fit: cover"
                    />
                  </v-avatar>
                  <v-avatar size="30px" v-else>
                    <img
                      height="30"
                      width="30"
                      alt="Avatar"
                      src="https://www.freeiconspng.com/thumbs/profile-icon-png/profile-icon-1.png"
                    />
                  </v-avatar>
                </button>
              </template>
              <v-card flat>
                <v-card-text class="text-subtitle-1">
                  <b class="ISlogin_text-style" style="text-transform:capitalize">
                    Hi, <span v-if="GetUserWeb?.FirstName === ' '" class="notranslate">{{ GetUserWeb?.LastName }}</span>
                    <span v-else class="notranslate">{{ GetUserWeb?.FirstName }}</span>
                  </b>
                  <v-divider class="my-3"></v-divider>
                  <v-list>
                    <div
                      v-for="navItem in filteredMenuLinks"
                      :key="navItem.name"
                    >
                      <div
                        style="
                          display: flex;
                          align-items: end;
                          gap: 1rem;
                          font-size: 20px;
                          color: rgba(34, 34, 34, 0.7);
                        "
                        class="mb-3"
                        v-if="navItem.name != 'divider'"
                      >
                        <router-link
                          style="text-decoration: none"
                          :to="navItem.route"
                          class="d-flex"
                        >
                          <span class="">
                            <v-img :src="navItem.iconn" class="px-0"></v-img>
                          </span>
                          <v-icon class="mr-4">{{ navItem.icon }}</v-icon>
                          <p class="ISlogin_text-style pa-0 ma-0">
                            {{ navItem.name }}

                            <!-- <template v-if="navItem.name === 'Manuals'">
                              <ChangeLanguageComponent
                                englishName="Manuals"
                                germanName="Lehrbucher"
                              />
                            </template>
                            <template v-else>
                              {{ navItem.name }}
                            </template> -->
                          </p>
                        </router-link>
                      </div>
                      <v-divider v-else class="my-2"></v-divider>
                    </div>
                  </v-list>
                  <v-divider class="my-3"></v-divider>
                  <v-card
                    class="cursor_pointer d-flex"
                    flat
                    to="/profile/membership"
                  >
                    <v-icon class="mr-4" style="color: #d18911"
                      >mdi-wallet-membership
                    </v-icon>
                    <span
                      class="ISlogin_text-style pa-0 ma-0"
                      style="color: #d18911"
                    >
                      Update <span>
                        <ChangeLanguageComponent
                                        :langName="languageObject.Membership"
                                      />
                                    </span>
                    </span>
                    <v-icon class="ml-6">mdi-chevron-right </v-icon>
                  </v-card>
                  <v-divider class="my-3"></v-divider>
                  <v-card flat to="/profile" class="mt-2 cursor_pointer">
                    <span class="ISlogin_text-style"> Account Settings </span>
                  </v-card>
                  <div
                    class="mt-3 pa-0 cursor_pointer"
                    block
                    color="transparent"
                    depressed
                    @click="SignOut"
                  >
                    <div style="width: 100%">
                      <div
                        class="ISlogin_text-style"
                        style="text-transform: none"
                      >
                        Sign Out
                      </div>
                    </div>
                  </div>
                </v-card-text>
              </v-card>
            </v-menu>
          </div>
        </div>
      </nav>
    </div>
    <div v-if="loginDialoag">
      <LoginModel
        :Dialog="loginDialoag"
        @CloseModel="CloseModel"
        @isLogined="isLogined"
      ></LoginModel>
    </div>
    <!------------------mobile navigation bar----------------------------------------->
    <v-navigation-drawer
      v-model="drawersearchmobile"
      absolute
      temporary
      style="z-index: 10000; width: 100%"
    >
      <v-row class="px-5">
        <v-col cols="11">
          <v-card outlined flat>
            <v-text-field
              dense
              solo
              background-color="#ECF1F2"
              v-model="searchInputField"
              append-icon="mdi-magnify"
              flat
              hide-details
              label="Search"
            ></v-text-field>
          </v-card>
        </v-col>
        <v-col cols="1" class="d-flex align-center">
          <v-icon @click="drawersearchmobile = false">mdi-close</v-icon>
        </v-col>
      </v-row>

      <v-divider></v-divider>

      <div class="px-5" v-if="searchInputField">
        {{ searchInputField }}
      </div>
      <div class="px-5" v-else>Searching coming soon</div>
    </v-navigation-drawer>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { mapGetters } from "vuex";

import LoginModel from "../../components/accounts/LoginModel.vue";
import LanguageComponent from "../../components/HomePage/Language.component.vue";
// import CurrencyComponent from "../../components/HomePage/CurrencyComponent.vue"
import ChangeLanguageComponent from "../../components/HomePage/ChangeLanguage.Component.vue";
import languageObject from "../../utils/index";
export default defineComponent({
  computed: {
    // ...mapGetters(["isLoggedIn", "GetUser", "getFlag", "GetCartItems", "GetUserWeb",]),
    ...mapGetters({
      userNotifications: "GetUserNotifications",
      isLoggedIn: "isLoggedIn",
      GetUser: "GetUser",
      getFlag: "getFlag",
      GetCartItems: "GetCartItems",
      GetUserWeb: "GetUserWeb",
      GetAllUserNotifications: "GetAllUserNotifications",
    }),
    notificationsCount() {
      return this.userNotifications?.notificationsCount || 0;
    },
    forumNotifications() {
      return this.userNotifications?.forumNotifications || [];
    },
    blogNotifications() {
      return this.userNotifications?.blogNotifications || [];
    },
    downloadNotifications() {
      return this.userNotifications?.downloadNotifications || [];
    },
    testimonialNotifications() {
      return this.userNotifications?.testimonialNotifications || [];
    },
    
    // filteredMenuLinks() {
    //   return this.GetUser.MemberShipId === 1 || this.GetUser.MemberShipId === 2
    //     ? this.userMenuItems.filter((item) => item.name2 !== "CEUs")
    //     : this.GetUser.AccountType === 3
    //     ? this.userMenuItemsInstructor
    //     : this.GetUser.MemberShipId === 3
    //     ? this.userMenuItems
    //     : this.GetUser.Username == 'master@iba.com'
    //     ? this.userMenuItemsInstructor
    //     : this.userMenuItems;
    // },
    filteredMenuLinks() {
      let menuItems = this.GetUser.Username === "master@iba.com" &&
        this.GetUserWeb?.AccountType === 2
        ? this.userMenuItemsInstructor
        : this.GetUserWeb?.AccountType === 3
        ? this.userMenuItemsInstructor
        : this.GetUserWeb?.MembershipDetail[0]?.MembershipID === 1 || this.GetUserWeb?.MembershipDetail[0]?.MembershipID === 2 || !this.GetUserWeb?.ExamsCredentials.includes(1) ? this.userMenuItems.filter((item) => item.name !== "CEUs")
        : this.GetUserWeb?.MembershipDetail[0]?.MembershipID === 3
        ? this.userMenuItems
        : this.userMenuItemsInstructor;
        // removing Forums access for this user with Id 3456
        if (this.GetUserWeb?.Id === 3456) {
          menuItems = menuItems.filter((item) => item.name !== "Forums");
        }

        return menuItems;
    },
     openUserMenu(){
      this.$store.dispatch("GetUserWeb", this.GetUser?.Id).then(() => {
        this.UserMenu = true;
      });
    },
    showIcon() {
      if (
        this.$route.path == "/store" ||
        this.$route.path.substr(0, 20) == "/store/storedetails/" ||
        this.$route.path == "/store/cart"
      ) {
        return true;
      }
      return false;
    },
    totalQuantity() {
      let quantity = 0;
      if (this.GetCartItems) {
        quantity = this.GetCartItems.reduce((total, item) => {
          return total + item.Quantity;
        }, 0);
      }
      return quantity;
    },
  },
  components: { LoginModel, LanguageComponent, ChangeLanguageComponent },
  // CurrencyComponent
  name: "Header",
  data() {
    return {
      languageObject,
      // obj: {
      //   English: "Practitioner",
      //   German: "Anwender",
      //   Portuguese: "Terapeuta",
      // },
      englishButtonText: "English",
      drawersearchmobile: false,
      searchInputField: "",
      showicon: false,
      foundationMenu: false,
      logo: require("./bodytalk-logo.svg"),
      LanguageDialog: false,
      LanguageDialog2: false,
      loginDialoag: false,
      isSidebarOpen: false,
      scrolled: false,
      isLogged: true, //if login
      UserMenu: false,
      userMenuItems: [
        // {
        //   route: "/",
        //   name: "My Admin",
        //   icon: "mdi-file-document-multiple-outline",
        // },
        // {
        //   route: "/downloads",
        //   name: "Instructor-Only Downloads",
        //   icon: "mdi-download",
        // },

        {
          name: "divider",
        },
        {
          route: "/profile",
          name: "Profile",
          icon: "mdi-account-circle",
        },
        {
          route: "/profile/courses",
          name: "Live Courses",
          // icon: "mdi-clipboard-text",
          icon: "mdi-school",
        },
        // {
        //   route: "/myselfstudy",
        //   name: "Self-Study Courses",
        //   icon: "mdi-home-edit-outline",
        // },

        {
          route: "/mymanuals",
          name: "Manuals",
          icon: "mdi-book-open-variant",
        },
        {
          route: "/downloads",
          name: "Downloads",
          icon: "mdi-progress-download",
        },
        {
          route: "/myceus",
          name: "CEUs",
          // iconn: require("../../assets/SvgIcons/haticon.svg"),
          iconn: require("../../assets/SvgIcons/admin_panel_settings.svg"),
        },
        {
          route: "/forum",
          name: "Forums",
          icon: "mdi-forum",
        },
        // {
        //   route: "/studygroupsandevents",
        //   name: "Study Groups and Events",
        //   // icon: "mdi-school",
        //   iconn: require("../../assets/SvgIcons/supervisor_account.svg"),
        // },
        {
          route: "/video",
          name: "Videos",
          icon: "mdi-play-box-multiple",
        },
        // {
        //   route: "/blog",
        //   name: "Blog",
        //   icon: "mdi-equal-box",
        // },
        {
          route: "/profile/credentials",
          name: "Certifications",
          icon: "mdi-card-account-details-outline",
        },
        // {
        //   route: "/",
        //   name: "Train for advanced certifications",
        //   icon: "mdi-home-edit-outline",
        // },
        // {
        //   route: "/",
        //   name: "Train to be an instructor",
        //   icon: "mdi-home-edit-outline",
        // },
      ],
      userMenuItemsInstructor: [
        {
          route: "/seminars",
          name: "Seminars",
          // icon: "mdi-file-multiple-outline",
          icon: "mdi-calendar",
        },
        {
          route: "/coordinators",
          name: " Coordinators",
          // icon: "mdi-calendar",
          iconn: require("../../assets/SvgIcons/face.svg"),
        },
        {
          route: "/location",
          name: "Locations",
          icon: "mdi-crosshairs-gps",
        },
        // {
        //   route: "/",
        //   name: "Admin",
        //   icon: "mdi-file-document-multiple-outline",
        // },
        // {
        //   route: "/downloads",
        //   name: "Instructor-Only Downloads",
        //   icon: "mdi-download",
        // },

        {
          name: "divider",
        },
        {
          route: "/profile",
          name: "Profile",
          icon: "mdi-account-circle",
        },
        {
          route: "/profile/courses",
          name: "Live Courses",
          // icon: "mdi-clipboard-text",
          icon: "mdi-school",
        },
        // {
        //   route: "/myselfstudy",
        //   name: "Self-Study Courses",
        //   icon: "mdi-home-edit-outline",
        // },

        {
          route: "/mymanuals",
          name: "Manuals",
          icon: "mdi-book-open-variant",
        },
        {
          route: "/downloads",
          name: "Downloads",
          icon: "mdi-progress-download",
        },
        {
          route: "/myceus",
          name: "CEUs",
          // iconn: require("../../assets/SvgIcons/haticon.svg"),
          iconn: require("../../assets/SvgIcons/admin_panel_settings.svg"),
        },
        {
          route: "/forum",
          name: "Forums",
          icon: "mdi-forum",
        },
        {
          route: "/studygroupsandevents",
          name: "Study Groups and Events",
          // icon: "mdi-school",
          iconn: require("../../assets/SvgIcons/supervisor_account.svg"),
        },
        {
          route: "/video",
          name: "Videos",
          icon: "mdi-play-box-multiple",
        },
        // {
        //   route: "/blog",
        //   name: "Blog",
        //   icon: "mdi-equal-box",
        // },
        {
          route: "/profile/credentials",
          name: "Certifications",
          icon: "mdi-card-account-details-outline",
        },
        // {
        //   route: "/",
        //   name: "Train for advanced certifications",
        //   icon: "mdi-home-edit-outline",
        // },
        // {
        //   route: "/",
        //   name: "Train to be an instructor",
        //   icon: "mdi-home-edit-outline",
        // },
      ],
    };
  },
  mounted() {
    if(this.isLoggedIn){
      this.fetchnotification();
    }
    this.englishButtonText = localStorage.getItem("LanguageName")
      ? localStorage.getItem("LanguageName")
      : this.englishButtonText;
    this.loginDialoag = this.$store.state.loginPopup;

    // const obj = {
    //   token: localStorage.getItem("token"),
    //   userId: localStorage.getItem("userId"),
    // };
    // if (obj.token) {
    //   this.$store.dispatch("ConfirmUserAccount", obj).then((res) => {
    //     if (res.Status == false) {
    //       this.$swal.fire({
    //         position: "top-end",
    //         icon: "success",
    //         title: res.Message,
    //         showConfirmButton: false,
    //         timer: 3000,
    //         toast: true,
    //       });
    //     } else {
    //       this.$swal.fire({
    //         position: "top-end",
    //         icon: "success",
    //         title: "Your Email Successfully confirmed",
    //         showConfirmButton: false,
    //         timer: 3000,
    //         toast: true,
    //       });
    //       this.loginDialoag = true;
    //     }
    //     localStorage.removeItem("userId");
    //     localStorage.removeItem("token");
    //   });
    // }
    
  },
  beforeRouteUpdate(to, from, next) {
    if (to.params.forumID !== from.params.forumID) {
      this.fetchNotificationData(to.params.forumID);
    }
    next();
  },
  watch: {
    "$route.params": {
      immediate: true,
      handler() {
        this.fetchNotificationData();
      },
    },
  },
  methods: {
    fetchNotificationData() {
      const forumID = this.$route.params.forumID;
      const ReferenceID = this.$route.params.ReferenceID;
      if (forumID) {
        // Logic to handle data fetching or updating for the forum ID
        this.$router.push(`/forum/postdetail/${this.forumNotifications.ReferenceID}`);
      }
      if (ReferenceID) {
        this.$router.push(`/forum/postdetail/${this.blogNotifications.ReferenceID}`);
      }
    },
    async markAsRead(notificationID) {
      const payload = {
        notificationID: notificationID,
        userID: this.GetUser.Id,
      };
      try {
        await this.$store.dispatch("MarkAsReadNotification", payload).then(() => {
          const userId = this.GetUser?.Id;
          this.$store.dispatch("GetAllUserNotifications", userId)
        });
      } catch (error) {
        console.error("Error marking notification as read:", error);
      }
    },
    formatTimeDifference(createdAt) {
      // Parse the CreatedAt string as UTC explicitly
      const utcTime = new Date(createdAt);

      // Get the local time by using the browser's local timezone
      const localTime = new Date(utcTime.getTime() - utcTime.getTimezoneOffset() * 60000);

      // Get the current local time
      const currentTime = new Date();

      // Calculate the time difference in milliseconds
      const timeDifferenceInMs = currentTime.getTime() - localTime.getTime();

      // Convert milliseconds to appropriate units
      const seconds = Math.floor(timeDifferenceInMs / 1000);
      const minutes = Math.floor(seconds / 60);
      const hours = Math.floor(minutes / 60);
      const days = Math.floor(hours / 24);
      const weeks = Math.floor(days / 7);

      // Return formatted time difference
      if (weeks > 0) {
        return `${weeks}w`;
      } else if (days > 0) {
        return `${days}d`;
      } else if (hours > 0) {
        return `${hours}h`;
      } else if (minutes > 0) {
        return `${minutes}m`;
      } else {
        return `${seconds}s`;
      }
    },
   
    async markAllNotificationsAsRead() {
      const notificationIDs = [
        ...this.userNotifications.notificationList.map((n) => n.NotificationID),
          // ...this.forumNotifications.map((n) => n.NotificationID),
          // ...this.blogNotifications.map((n) => n.NotificationID),
          // ...this.downloadNotifications.map((n) => n.NotificationID),
          // ...this.testimonialNotifications.map((n) => n.NotificationID),
        ];
      
      try {
        if (notificationIDs?.length === 0) {
          this.$swal.fire({
            position: "top-end",
            icon: "info",
            title: "No notifications to mark as read.",
            showConfirmButton: false,
            timer: 3000,
            toast: true,
          });
          return;
        }
        const payload = {
          notificationIDs: notificationIDs,
          userID: this.GetUser?.Id,
        };
        await this.$store.dispatch("MarkAllNotificationAsRead", payload);
          const userId = this.GetUser?.Id;
          await this.$store.dispatch("GetAllUserNotifications", userId);
      } catch (error) {
        console.error("Error marking all notifications as read:", error);
      }
    },
    close() {
      this.LanguageDialog = false;
      this.LanguageDialog2 = false;
    },
    setDefaultImage(event) {
      event.target.src = 'https://www.freeiconspng.com/thumbs/profile-icon-png/profile-icon-1.png'
    },
    updateEnglishButtonText(lang, name) {
      this.englishButtonText = name;
    },
    openLogin() {
      this.loginDialoag = true;
    },
    fetchnotification() {
      const userId = this.GetUser?.Id;
      this.$store.dispatch("GetAllUserNotifications", userId)
      this.$store.dispatch("GetCheckUserMembershipExpiration", userId)
    },
    CloseModel() {
      this.loginDialoag = false;
      this.$store.state.loginPopup = false;
    },
    isLogined() {
      this.isLogged = false;
      this.loginDialoag = false;
      this.$store.state.loginPopup = false;
    },
    SignOut() {
      this.$store.dispatch("Logout");
      // window.location.reload();
      // this.$router.push("/");
       if (this.$route.path !== "/") {
        this.$router.push("/");
      }
      this.$store.state.redirectToPreviousRoute = "";
      this.$swal.fire({
        position: "top-end",
        icon: "success",
        title: "Logged Out Successfully",
        showConfirmButton: false,
        timer: 3000,
        toast: true,
      });
    },
    contactusmodel() {
      this.$store.dispatch("ToggleContact", true);
    },
  },
});
</script>

<style scoped lang="scss">
.notification-item {
  transition: background-color 0.3s ease;
  cursor: pointer;
}

.notification-unread {
  background-color: #edf0f6;
}

.notification-unread:hover {
  background-color: #d2ddf1;
}

.notification-read {
  background-color: #ffffff; /* White background */
}

.notification-read:hover {
  background-color: #f7f7f7; /* Slightly darker gray on hover */
}
.scrollable-container {
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none; /* IE 10+ */
}

.scrollable-container::-webkit-scrollbar {
  display: none; /* Chrome, Safari, and Edge */
}
@media(min-width:960px){
  .mbl-notification-card{
    display:none;
  }
}
.side_btns_styles {
  button[type="button"] {
    padding-top: 0px !important;
    padding-bottom: 0px !important;
    margin-top: 0px !important;
    margin-bottom: 0px !important;
  }
}

.spacing_header_div {
  // background-color: red;
  button[type="button"]:not(:last-child) {
    margin-right: 1rem;
  }
}

.nav_left {
  width: 100%;
  display: grid;
  grid-template-columns: 140px 1fr;
}

.search_bar_parrent {
  display: flex;
  align-items: center;
  justify-content: space-between;

  .search {
    width: 100%;
    max-width: 318px;

    input {
      width: 100%;
    }
  }
}

.LanguageDialog_span {
  color: rgba(34, 34, 34, 0.7);
  transition: all 0.3s ease;
  letter-spacing: -0.25px !important;
  font-family: "DM Sans", sans-serif;
  font-size: 14px;
  font-weight: 500;
}

.v-input--density-default {
  --v-input-control-height: 50px;
  --v-input-padding-top: 16px;
}

.text {
  font-family: "DM Sans", sans-serif;
  font-size: 14px;
  line-height: 45.6px;
  font-weight: 500;
  text-transform: none;
  letter-spacing: 0px;
  color: #595459;
}

element.style {
  max-height: 451px;
  max-width: 1559px;
  min-width: 188.875px;
  --v-overlay-anchor-origin: bottom left;
  transform-origin: left top;
  top: 140px;
  left: 880px;
}

@media screen and (max-width: 959px) {
  .Our_Modalities_style {
    top: 7.2em !important;
    right: 0%;
  }
  .desktop-notification-card{
    display:none;
  }
}

.Our_Modalities_style_h1 {
  font-family: "DM Sans";
  font-size: 13px;
  display: block;
  text-align: left;
  font-weight: 500;
  letter-spacing: 0;
}

.Our_Modalities_style_span {
  letter-spacing: 0;
  font-family: "DM Sans";
  font-size: 12px;
  font-weight: 400;
  display: block;
  text-align: left;
  color: rgba(34, 34, 34, 0.7);
  text-transform: none;
}

.ISlogin_text-style {
  font-family: "DM Sans";
  font-size: 16px;
  color: rgba(34, 34, 34, 0.7);
}
.cart-badge, .notification-badge {
  position: absolute;
  top: -10px;
  right: 3px;
  color: #ffffff;
  border-radius: 50%;
  // text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 20px;
  width: 20px;
  padding: 0px 4px;
  font-size: 12px;
}
.notification-badge{
  background-color: #5757db;
}
.cart-badge{
  background-color: red;
}
.cart-icon-container, .notification-icon-container {
  position: relative;
  cursor: pointer;
}
</style>
